import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import SimpleInput from "../../components/Frequents/SimpleInput";
import SimpleReadOnly from "../../components/Frequents/SimpleReadOnly";
import SelectTreatment from "../../components/Frequents/SelectTreatment";
import FindClient from "../../components/Frequents/FindClient";
import Clock from "../Frequents/TimePicker.js";
import { AppBar, Toolbar, Typography, FormControlLabel, Checkbox, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import API from "../../actions";
import update from "immutability-helper";
import moment from "moment";
import { getDKDateTimeRange, isNotDKTimeZone } from "../../libs/dktime";

const useStyles = makeStyles({
    list: {
        width: 250
    },
    fullList: {
        width: "auto"
    },
    appBar: { backgroundColor: "#fff", color: "#000" },
    paper: {
        height: "100%"
    }
});

function getDayTimestamps(date) {
    const now = new Date(date);

    // Start of the day (00:00:00)
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startTimestamp = startOfDay.getTime();

    // End of the day (23:59:59.999)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
    const endTimestamp = endOfDay.getTime();

    return {
        startTimestamp,
        endTimestamp
    };
}

export default props => {
    const classes = useStyles();

    const [error, showError] = React.useState("");
    const [treatmentArray, setTreatmentArray] = useState([]);
    const [clientArray, setClientArray] = useState([]);
    const [newClient, setNewClient] = useState(false);
    const [booking, setBooking] = useState({});
    const [time, setTime] = useState(null);
    const [toTime, setToTime] = useState(null);
    const [duration, setDuration] = useState(0);
    //const [cpr6Digit, setCPR6Digit] = useState("");
    //const [cprLast4Digit, setCPRLast4Digit] = useState("");
    const saveBooking = async () => {
        const bookings = (
            await API.getLeavesForDay({
                from: getDayTimestamps(props.dateInfo.date).startTimestamp,
                to: getDayTimestamps(props.dateInfo.date).endTimestamp
            })
        ).map(b => ({ from: +b.from, to: +b.to }));

        function isOverlapsBooking(startTimestamp, endTimestamp) {
            for (let i = 0; i < bookings.length; i++) {
                if (startTimestamp < bookings[i].to && endTimestamp > bookings[i].from) {
                    return true;
                }
            }
            return false;
        }

        if (
            isOverlapsBooking(
                moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf(),
                moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf() + 1000 * duration
            )
        ) {
            showError("Denne tidspunkt overlapper med en anden booking. Vælg en anden tidspunkt.");
            return;
        }

        if (!leave) {
            const mailFormat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
            const phoneFormat = /^\+*\d{8,}$/;
            booking.CPR = booking.CPR6Digit + booking.CPRLast4Digit;
            let errorMsg = "Fejl i oprettelse af booking. Tjek at alle obligatoriske felter er udfyldt.";

            if (newClient) {
                if (booking.nameFirst === "") {
                    errorMsg = "Fejl: Fornavn er påkrævet.";
                    showError(errorMsg);
                    return;
                } else if (booking.nameLast === "") {
                    errorMsg = "Fejl: Efternavn er påkrævet.";
                    showError(errorMsg);
                    return;
                } else if (booking.CPR6Digit.length !== 6) {
                    errorMsg = "Fejl: Fødselsdag skal være 6 cifre.";
                    showError(errorMsg);
                    return;
                } else if (booking.CPRLast4Digit.length !== 4) {
                    errorMsg = "Fejl: De sidste 4 cifre i dit CPR nr skal bestå af 4 tegn.";
                    showError(errorMsg);
                    return;
                }
                if (booking.email === "" || !(booking.email || "").match(mailFormat)) {
                    errorMsg = "Fejl: Invalid email adresse";
                    showError(errorMsg);
                    return;
                } else if (
                    booking.phonePrivate === "" ||
                    !(booking.phonePrivate || "").replace(/\s/g, "").match(phoneFormat)
                ) {
                    errorMsg = "Fejl: Telefonnummer skal være mindst 8 cifre og må ikke indeholde specialtegn udover +";
                    showError(errorMsg);
                    return;
                }
            }
            if (!booking.treatmentId) {
                errorMsg = "Fejl: Behandling er påkrævet.";
                showError(errorMsg);
                return;
            }
            const b = update(booking, {
                from: { $set: moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf() },
                to: {
                    $set: moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf() + 1000 * duration
                },
                bookingDate: {
                    $set: moment(props.dateInfo.date).format("YYYY-MM-DD")
                }
            });

            API.addBooking(b).then(
                success => props.close(),
                err => {
                    showError(err);
                }
            );
        } else {
            if (!time) {
                showError("Fejl: Tid er påkrævet.");
            }
            if (!toTime) {
                showError("Fejl: Tid er påkrævet.");
            }
            if (!booking.reason) {
                showError("Fejl: Afsnitt er påkrævet.");
            }

            if (!time || !toTime || !booking.reason) return;

            API.addLeave({
                reason: booking.reason,
                from: moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf(),
                to: moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + toTime).valueOf()
            }).then(
                success => props.close(),
                err => {
                    showError(err);
                }
            );
        }
        const calendarApi = props.calendarRef.current?.getApi();
        if (calendarApi && props.currentViewDate) {
            calendarApi.gotoDate(props.currentViewDate);
        }
    };

    const get4lastDigitCPR = async () => {
        var result = await API.get4LastDigitCPR();
        if (result) {
            //setCPRLast4Digit(result.lastDigit);
            setBooking(
                update(booking, {
                    CPRLast4Digit: { $set: result.lastDigit }
                })
            );
        }
    };

    useEffect(() => {
        (async () => {
            setTime(moment(props.dateInfo.date).format("HH:mm:ss"));
            setToTime(moment(props.dateInfo.date).format("HH:mm:ss"));
            //setTreatmentArray(await API.getAvailableTreatmentsFromTherapist());
            setClientArray(await API.getClientsFromTherapistCompany());
        })();
    }, [props.dateInfo.date]);

    useEffect(() => {
        (async () => {
            if (newClient) {
                setTreatmentArray(await API.getAvailableTreatmentsFromTherapist());
            } else {
                setTreatmentArray(await API.getTreatmentsFromTherapist());
            }
        })();
    }, [newClient]);

    const [leave, setLeave] = useState(false);

    return (
        <>
            <Drawer anchor="bottom" open={Boolean(props.dateInfo)} onClose={props.close}>
                <AppBar position="static" className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            className={classes.menuButton}
                            color="inherit"
                            aria-label="menu"
                            onClick={props.close}>
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Opret Booking
                        </Typography>
                    </Toolbar>
                </AppBar>

                <Container maxWidth="md" style={{ height: "100%", paddingTop: "20px" }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={newClient}
                                onChange={() => {
                                    setBooking(
                                        // clear client infor
                                        update(booking, {
                                            clientId: { $set: "" },
                                            nameFirst: { $set: "" },
                                            nameLast: { $set: "" },
                                            CPR: { $set: "" },
                                            CPR6Digit: { $set: "" },
                                            CPRLast4Digit: { $set: "" },
                                            email: { $set: "" },
                                            phonePrivate: { $set: "" }
                                        })
                                    );
                                    setLeave(false);
                                    setNewClient(!newClient);
                                }}
                                value="checkedNew"
                                color="primary"
                            />
                        }
                        label="Ny klient?"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={leave}
                                onChange={() => {
                                    setNewClient(false);
                                    setLeave(!leave);
                                }}
                                value="checkedNew"
                                color="primary"
                            />
                        }
                        style={{ float: "right", marginRight: 0 }}
                        label="ikke tilgængelig"
                    />
                    {!leave &&
                        (newClient ? (
                            <>
                                <Grid container spacing={0}>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleInput
                                            id="newClientFirstName"
                                            name="newClientFirstName"
                                            key="newClientFirstName"
                                            text="Fornavn"
                                            prop={booking.nameFirst ? booking.nameFirst : ""}
                                            required={true}
                                            changeValue={value =>
                                                setBooking(
                                                    update(booking, {
                                                        nameFirst: { $set: value }
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleInput
                                            id="newClientLastName"
                                            style={{ flex: 1 }}
                                            name="newClientLastName"
                                            text="Efternavn"
                                            prop={booking.nameLast ? booking.nameLast : ""}
                                            required={true}
                                            changeValue={value =>
                                                setBooking(
                                                    update(booking, {
                                                        nameLast: { $set: value }
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleInput
                                            style={{ flex: 1 }}
                                            id="CPR6Digit"
                                            name="CPR6Digit"
                                            type="number"
                                            text="Fødselsdag"
                                            required={true}
                                            prop={booking.CPR6Digit ? booking.CPR6Digit : ""}
                                            changeValue={value =>
                                                setBooking(
                                                    update(booking, {
                                                        CPR6Digit: { $set: value }
                                                    })
                                                )
                                            }
                                            maxLength={6}
                                        />
                                    </Grid>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleInput
                                            style={{ flex: 1 }}
                                            id="CPRLast4Digit"
                                            name="CPRLast4Digit"
                                            type="CPRLast4Digit"
                                            text="De sidste 4 cifre i dit CPR nr"
                                            required={true}
                                            prop={booking.CPRLast4Digit ? booking.CPRLast4Digit : ""}
                                            changeValue={value =>
                                                setBooking(
                                                    update(booking, {
                                                        CPRLast4Digit: { $set: value }
                                                    })
                                                )
                                            }
                                            maxLength={4}
                                        />
                                        {/* <Button
                                        variant="contained"
                                        onClick={get4lastDigitCPR}
                                        style={{ margin: "10px 0 10px 0", fontFamily: "Lato" }}>
                                        Generer unik kode
                                    </Button> */}
                                    </Grid>
                                    <Grid item sm={6} style={{ width: "100%" }}>
                                        <SimpleInput
                                            id="email"
                                            name="email"
                                            key="email"
                                            text="Email"
                                            prop={booking.email ? booking.email : ""}
                                            required={true}
                                            changeValue={value =>
                                                setBooking(
                                                    update(booking, {
                                                        email: { $set: value }
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                    <Grid item sm={6} style={{ width: "100%" }}>
                                        <SimpleInput
                                            id="phonePrivate"
                                            name="phonePrivate"
                                            key="phonePrivate"
                                            text="Telefonnummer"
                                            prop={booking.phonePrivate ? booking.phonePrivate : ""}
                                            required={true}
                                            changeValue={value =>
                                                setBooking(
                                                    update(booking, {
                                                        phonePrivate: { $set: value }
                                                    })
                                                )
                                            }
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        ) : (
                            <>
                                <FindClient
                                    clients={clientArray}
                                    journals={false}
                                    changeValue={value => {
                                        setBooking(
                                            update(booking, {
                                                clientId: { $set: value.id },
                                                nameFirst: { $set: value.nameFirst },
                                                nameLast: { $set: value.nameLast },
                                                CPR: { $set: value.CPR },
                                                CPR6Digit: { $set: value.CPR6Digit },
                                                CPRLast4Digit: { $set: value.CPRLast4Digit },
                                                email: { $set: value.email },
                                                phonePrivate: { $set: value.phonePrivate }
                                            })
                                        );
                                    }}
                                />
                                <Grid container spacing={0}>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleReadOnly
                                            text="Fornavn"
                                            prop={booking.nameFirst ? booking.nameFirst : ""}
                                        />
                                    </Grid>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleReadOnly
                                            style={{ flex: 1 }}
                                            text="Efternavn"
                                            prop={booking.nameLast ? booking.nameLast : ""}
                                        />
                                    </Grid>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleReadOnly
                                            style={{ flex: 1 }}
                                            text="Fødselsdag"
                                            prop={booking.CPR6Digit ? booking.CPR6Digit : ""}
                                        />
                                    </Grid>
                                    <Grid item sm={3} style={{ width: "100%" }}>
                                        <SimpleReadOnly
                                            style={{ flex: 1 }}
                                            text="De sidste 4 cifre i dit CPR nr"
                                            prop={booking.CPRLast4Digit ? booking.CPRLast4Digit : ""}
                                        />
                                    </Grid>
                                    <Grid item sm={6} style={{ width: "100%" }}>
                                        <SimpleReadOnly text="Email" prop={booking.email ? booking.email : ""} />
                                    </Grid>
                                    <Grid item sm={6} style={{ width: "100%" }}>
                                        <SimpleReadOnly
                                            text="Telefonnummer"
                                            prop={booking.phonePrivate ? booking.phonePrivate : ""}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        ))}
                    {!leave && (
                        <SelectTreatment
                            name="treatmentSelect"
                            text="Behandling"
                            id="treatmentSelect2"
                            treatments={treatmentArray}
                            required={true}
                            changeValue={async value => {
                                const treatment = await API.getTreatment(value);
                                setBooking(
                                    update(booking, {
                                        treatmentId: { $set: treatment.id }
                                    })
                                );
                                setDuration(treatment.duration);
                            }}
                        />
                    )}
                    <Grid container spacing={0}>
                        <Grid item sm={4} style={{ width: "100%" }}>
                            <SimpleReadOnly
                                id="newBookingDate"
                                name="newBookingDate"
                                text="Dato"
                                prop={moment(props.dateInfo.date).format("DD/MM/YYYY")}
                            />
                        </Grid>
                        <Grid item sm={4} style={{ width: "100%" }}>
                            <Clock
                                id="newBookingFrom"
                                style={{ flex: 1 }}
                                value={time}
                                changeValue={setTime}
                                text="fra"
                            />
                        </Grid>
                        {leave && (
                            <Grid item sm={4} style={{ width: "100%" }}>
                                <Clock
                                    id="newBookingFrom"
                                    style={{ flex: 1 }}
                                    value={toTime}
                                    changeValue={setToTime}
                                    text="til"
                                />
                            </Grid>
                        )}
                        {!leave && (
                            <Grid item sm={4} style={{ width: "100%" }}>
                                <SimpleReadOnly
                                    id="newBookingTo"
                                    style={{ flex: 1 }}
                                    name="newBookingTo"
                                    text="Slut"
                                    prop={
                                        time
                                            ? moment(
                                                  new Date(Number(Date.parse("1970-01-01T" + time) + 1000 * duration))
                                              ).format("HH:mm:ss")
                                            : ""
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                    {isNotDKTimeZone() && (
                        <div class="dk-time">
                            Du er ikke DK-tidszone, dette er tid i DK-tidszone:{" "}
                            {getDKDateTimeRange(
                                moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf(),
                                moment(moment(props.dateInfo.date).format("YYYY-MM-DDT") + time).valueOf() +
                                    1000 * duration
                            )}
                        </div>
                    )}
                    <SimpleInput
                        name="newBookingReason"
                        text="Årsag"
                        id="newBookingReason"
                        multiline={true}
                        prop={booking.reason}
                        changeValue={value =>
                            setBooking(
                                update(booking, {
                                    reason: { $set: value }
                                })
                            )
                        }
                    />

                    <Button
                        variant="contained"
                        onClick={saveBooking}
                        style={{ margin: "10px 0 10px 0", fontFamily: "Lato" }}>
                        Gem
                    </Button>
                    {error !== "" ? (
                        <Typography color="secondary" variant="subtitle2" gutterBottom>
                            {error}
                        </Typography>
                    ) : null}

                    <div style={{ height: "40px" }}></div>
                </Container>
            </Drawer>
        </>
    );
};
